// removed by extract-text-webpack-plugin
module.exports = {"poes":"about__poes___21onx","mwl":"about__mwl___1_JZb","fronteers":"about__fronteers___1uF6Q"};


//////////////////
// WEBPACK FOOTER
// ./src/js/Pages/About/about.scss
// module id = 133
// module chunks = 0